import { ContainsPipe } from '@abb-procure/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { SearchState } from '../../store/search.state';
import { SearchFacets } from '../search-facets/search-facets.component';
import { SearchFilter } from '../search-filter/search-filter.component';

@Component({
  selector: 'procure-search-filters',
  templateUrl: './search-filters.component.html',
  styleUrl: './search-filters.component.scss',
  imports: [SearchFilter, SearchFacets, ContainsPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilters {
  protected readonly globalFilters = computed(() => this.state.globalFilters());

  protected readonly disabledGlobalFilters = computed(() =>
    this.state.disabledGlobalFilters(),
  );

  protected readonly activeTab = computed(() => this.state.activeTab());

  private readonly state = inject(SearchState);
}
